
//防抖，一段时间内执行一次，如果在这个时间段内再次触发，重新计算时间（用作提交类事务，防止重复提交）,设置immediately决定是否立即触发
export const debounce = (fn: any, delay: number) => {
  let timer: any;
  return () => {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        fn()
      }, delay)
  }
}
//节流，在一段时间内，函数最多可以触发一次,设置immediately决定是否立即触发
export const throttle = (fn: any, delay: number, immediately = true) => {
  let isThtottle = true
  return () => {
    if (!isThtottle) return
    isThtottle = false
    if (immediately) {
      fn()
      setTimeout(() => {
        isThtottle = true
      }, delay)
    } else {
      setTimeout(() => {
        fn()
        isThtottle = true
      }, delay)
    }
  }
}
/**
 * 时间格式化到秒
 * @param timeStamp
 */
export const formatterTimeStampToSecond = (timeStamp: number | string) => {
  if (timeStamp) {
    const date = new Date(timeStamp);
    const year = date.getFullYear(),
      month = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2),
      hour = ("0" + date.getHours()).slice(-2),
      minute = ("0" + date.getMinutes()).slice(-2),
      second = ("0" + date.getSeconds()).slice(-2);
    // 拼接 + 返回
    return year + "-" + month + "-" + day  + " " + hour + ":" + minute+':'+second;
  } else {
    return "";
  }
};
//去除富文本
export const formatText = (text:string) => {
  let returnText = ''
  const test = new RegExp("<.+?>", "g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
  returnText = text.replace(test, '').replace(/(<br\s?\/?>)+/gi, '$1').replace(/^<br\/>|<br>/g, '');
  return returnText
}

